export const header = {
    "home_page": "Home page",
    "study_program": "Curricula",
    "study_program_sort": "Curricula",
    "change_language": "Change language",
    "vietnamese": "Vietnamese",
    "english": "English",
};
